import React from 'react';
import { StyleSheet, View } from 'react-native';
import { AppView, rem } from 'design-system';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { useMarginBottom } from 'hooks/useMarginBottom';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import InformationLabelList from '../components/InformationLabelList';
const InformationLabel = withAnimatedNavigationHeader(({ route, scrollY }) => {
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        // eslint-disable-next-line no-param-reassign
        scrollY.value = handle.contentOffset.y;
    });
    const paddingBottom = useMarginBottom('paddingBottom', rem(16), styles.wrap);
    return (<AppView type="primary">
        <Animated.ScrollView contentContainerStyle={paddingBottom} scrollEventThrottle={16} onScroll={scrollHandler}>
          <View style={styles.section}>
            <InformationLabelList info={route.params.informationLabel} filter="gas"/>
          </View>
          <View style={styles.section}>
            <InformationLabelList info={route.params.informationLabel} filter="electricity"/>
          </View>
        </Animated.ScrollView>
      </AppView>);
}, ({ colors }) => ({
    title: 'Tariff Information',
    headerColorOutputRange: [
        colors.background.light,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    wrap: {
        padding: rem(16),
    },
    section: {
        marginBottom: rem(20),
    },
});
export default InformationLabel;
